export enum DecisionKindCodesEnum {
  VO = 'VO',
  MO = 'MO',
  PR = 'PR',
  PGK = 'PGK',
  NSOT = 'NSOT',
}
